module.exports = __webpack_public_path__ + "static/media/annalp.ba6193e3.jpg";